import { parseErrors, Toast } from 'helpers';
import { getTasksCount } from 'queries';
import { useQuery } from 'react-query';
import { JsonDataItem } from 'types';

type TaskCounts = Awaited<ReturnType<typeof getTasksCount>>;

function useTaskCount(): { taskCounts?: TaskCounts; refresh: () => void; isLoading: boolean } {
  const { data, refetch, isLoading } = useQuery('task-count', getTasksCount, {
    refetchInterval: 300000, // check every 5 min
    staleTime: 300000,
    onError: (data: JsonDataItem) => {
      Toast.show({ description: parseErrors(data).join(', '), type: Toast.Type.Error });
    },
  });

  return { taskCounts: data, refresh: refetch, isLoading };
}

export { useTaskCount };
